import { __awaiter } from "tslib";
import * as constants from './constants.js';
import { selectorCycleTimepoint, warningSelector } from './constants.js';
import { Utils } from './utils.js';
import { toUpper } from 'lodash-es';
import { delay } from './automation/delay.js';
import { waitForElementByInterval } from './automation/waitForElementByInterval.js';
import dompurify from 'dompurify';
const warningIconImageHtml = `<img
 width="14"
 height="14"
 style="width:14px;height:14px;transform:scale(0.5)"
 src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAAAXNSR0IArs4c6QAAAgZJREFUSEu9ls9PE0EUx79vFlG3hlBTJdliFSIBLpCY+A9oKBdNOHjQg4l/kFfuJiZy4UCiF0pIuHMgYCIYf1QhbUSIGkIb0O48M0P6Yy3dmXbM7l422TfvM+877715xMwM01P5Aj7+Cq6UUascwKPfIPX2XQb3p0GpAHTlJpC6ZfIEigPyz03Iww3Q6aHRkTLgixmIzB1Qeqqj/fnAk++Q5VWgWrICtRn5WYjgPnDpetuvduDRe8jdN2q/vcEaqwgi9wAYGI/4iQI17LUjKLpc5B5GoE2gkvHjy9jI9vePUChsRzzm85MYGhqI2SRB3H7akLcBlJ8XjGdWLv/C0tJWxPnc3BSCYDBeFXWmo0+0jQaqbOTSilHKnoEKlJ0BpafPgOGHF1ap7wJUJeONPQPxcZFlcdEYnTJwAar1YuQRSH5bYz5YTwRI1+6Cwk+v2LbAXSOEnwXJd/PMYTWZCD0fFL59zrZdxTlC1fC7AarCX17eiagxOzthKPxWcwLJ7Xnmmp2kVrrH9Zw+JWkXSeMKPEuaLsrCFajLopvCr1b/YHfvR4Sbu3EVvn/Bai+68JNvbbp5b4FLBeMuXcqCsnk9eiR0PQ1DjD5uXk/6y+IC7i3CDhewhhpGjDCUUInT+qiE8TzR8Tg6jxj1JYkOUXWo85g4DBHcsxwTW8RJbhD+90T+46j/F0flYVX3SYYgAAAAAElFTkSuQmCC"
 alt="">`;
const scheduleOfActivitiesWarningLegend = `
<div class="warning-legend">${warningIconImageHtml}<span>This activity is not completely configured.</span></div>
`;
export class TableWidgets {
    constructor(maxDocxColumnCount) {
        this.maxDocxColumnCount = maxDocxColumnCount;
    }
    /**
     * Scrapes Schedule of Activities widgets and converts it to HTML table
     * @return {string} - valid HTML table
     */
    getScheduleOfActivity(stageName) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c, _d, _f, _g, _h, _j, _k, _l, _m;
            const scheduleOfActivities = Utils.cloneNode(constants.widgets.scheduleOfActivities.dataDocumentParserId);
            const grid = scheduleOfActivities === null || scheduleOfActivities === void 0 ? void 0 : scheduleOfActivities.querySelectorAll(constants.selectorSoaGrid);
            const gridStructure = [];
            const hasWarning = (scheduleOfActivities === null || scheduleOfActivities === void 0 ? void 0 : scheduleOfActivities.querySelector(warningSelector)) != null;
            const footNotes = {};
            const isAnyDay = (dataAutomationRole) => constants.selectorAnyDayRule.includes(dataAutomationRole);
            stageName = dompurify.sanitize(stageName.replace(/\s/, '-'));
            for (const el of Array.from(grid !== null && grid !== void 0 ? grid : [])) {
                const footNotesLinks = el.querySelectorAll(constants.selectorFootNote);
                if (footNotesLinks.length) {
                    footNotesLinks.forEach(e => {
                        var _a;
                        e.outerHTML = dompurify.sanitize(` <a class="link" href="#footnote${stageName}${(_a = e.textContent) === null || _a === void 0 ? void 0 : _a.trim()}">${dompurify.sanitize(e.innerHTML)}</a>`);
                    });
                }
                // each div is converted into a new paragraph, need to be replaced with span
                el.innerHTML = el.innerHTML.replace(/<div/gi, '<span').replace(/div>/gi, 'span>');
                const textContent = (_a = el.textContent) === null || _a === void 0 ? void 0 : _a.trim();
                const style = ((_b = el.getAttribute('style')) !== null && _b !== void 0 ? _b : '')
                    .replace(/grid-area: /gi, '')
                    .replace(/span /gi, '')
                    .split('/');
                if (style.length > 3 && style[3].includes('column-count')) {
                    const colSpan = style[3].replace('--column-count:', '').split(';');
                    style.push(colSpan[1]);
                    style[3] = colSpan[0];
                }
                if (style[2] && Number(style[2]) > 1)
                    continue;
                style[3] = (_c = style[3]) === null || _c === void 0 ? void 0 : _c.replace(';', '');
                if (textContent) {
                    el.querySelectorAll('button').forEach(b => (b.outerHTML = b.innerHTML));
                    if ((_d = el.getAttribute('data-document-parser-role')) === null || _d === void 0 ? void 0 : _d.includes(constants.epochHeaderCell)) {
                        const epochDisplayName = el.querySelector(`[data-document-parser-role^="${constants.EpochDisplayName}"]`);
                        const epochDescription = el.querySelector(`[data-document-parser-id="${constants.epochDescription}"]`);
                        if (epochDescription) {
                            epochDescription.innerHTML = `<div>${dompurify.sanitize(epochDescription.textContent)}</div>`;
                        }
                        if (epochDisplayName) {
                            epochDisplayName.innerHTML = `<div>${dompurify.sanitize(epochDisplayName.textContent)}</div>`;
                        }
                    }
                    gridStructure.push({
                        classes: [],
                        grid: style === null || style === void 0 ? void 0 : style.map(s => s.trim()),
                        value: Utils.cleanClasses(el.outerHTML),
                        dataAutomationRole: (_f = el.getAttribute('data-document-parser-role')) !== null && _f !== void 0 ? _f : '',
                        id: isAnyDay((_g = el.getAttribute('data-document-parser-role')) !== null && _g !== void 0 ? _g : '') ? (_h = el.id) !== null && _h !== void 0 ? _h : '' : '',
                    });
                }
                else {
                    const gridCell = {
                        classes: [],
                        grid: style === null || style === void 0 ? void 0 : style.map(s => s.trim()),
                        value: '',
                        dataAutomationRole: (_j = el.getAttribute('data-document-parser-role')) !== null && _j !== void 0 ? _j : '',
                        id: '',
                    };
                    if ((_k = el.getAttribute('data-document-parser-role')) === null || _k === void 0 ? void 0 : _k.includes(constants.selectorBullet)) {
                        const hasCycle = el.querySelector(`[${selectorCycleTimepoint}]`) != null;
                        gridCell.value = `<span class="bullet ${hasCycle ? 'cycle' : ''}">•</span>`;
                    }
                    gridStructure.push(gridCell);
                }
            }
            const activities = scheduleOfActivities === null || scheduleOfActivities === void 0 ? void 0 : scheduleOfActivities.querySelectorAll(constants.selectorSoaActivities);
            Array.from(activities !== null && activities !== void 0 ? activities : []).forEach((activity, index) => {
                var _a;
                activity.querySelectorAll('button').forEach(b => b.remove());
                let tagsContainerHtml = '&nbsp;';
                const tagsContainer = activity.querySelectorAll(constants.selectorActivityTagsContainer);
                if (tagsContainer.length === 1) {
                    const tags = tagsContainer[0].querySelectorAll(constants.selectorActivityTags);
                    if (tags.length > 0) {
                        tags.forEach(tag => {
                            tagsContainerHtml += `<span style="color: #1462ff">${dompurify.sanitize(tag.textContent)}</span>&nbsp;`;
                        });
                    }
                    tagsContainer[0].outerHTML = tagsContainerHtml;
                }
                gridStructure.push({
                    classes: [],
                    grid: [(index + constants.headerRowsCountOfSOA + 2).toString(), '1', '1', '1'],
                    value: `<div class="activities-column"><div>${Utils.cleanClasses(activity.outerHTML)}</div></div>`,
                    dataAutomationRole: (_a = activity.getAttribute('data-document-parser-role')) !== null && _a !== void 0 ? _a : '',
                    id: '',
                });
            });
            const getRowNumber = (cell) => parseInt(cell.grid[0], constants.numberRadix) - 1;
            const getColNumber = (cell) => parseInt(cell.grid[1], constants.numberRadix);
            const getColSpan = (cell) => cell.value && cell.grid[3] ? parseInt(cell.grid[3], constants.numberRadix) : 0;
            const createEmptyRow = () => Array.from({ length: maxCol + 1 }, () => ({
                content: '',
                classes: [],
                dataAutomationRole: '',
                colspan: 0,
                rowspan: 0,
            }));
            // define the size of the table
            const maxRow = Math.max(...gridStructure.map(el => getRowNumber(el) + 1));
            const maxCol = Math.max(...gridStructure.map(el => getColNumber(el)));
            // initialize the table with empty rows
            const tableStructure = Array.from({ length: maxRow }, createEmptyRow);
            const bars = [];
            const additionalRows = [];
            const intersections = [];
            const placedBarIds = new Set();
            function sanitizeHtmlContent(html) {
                return html
                    .replace(/<input\s+([^>]+)>/gi, '')
                    .replace(/<span[^>]*>to<\/span>/gi, '<span class="to-span"> to </span>');
            }
            function renderRegularCell(cell, content, y, x, colspan) {
                tableStructure[y][x].content = content;
                tableStructure[y][x].classes.push(...cell.classes);
                tableStructure[y][x].dataAutomationRole = cell.dataAutomationRole;
                tableStructure[y][x].colspan = colspan;
            }
            function renderBar(bar, y) {
                const x = getColNumber(bar);
                const colspan = getColSpan(bar);
                bars[getRowNumber(bar)] = [...(bars[getRowNumber(bar)] || []), [x, colspan]];
                const cellValue = Utils.wrapElementIntoDiv(bar.value);
                const sanitized = sanitizeHtmlContent(cellValue.innerHTML);
                const hasCycle = sanitized.search(selectorCycleTimepoint) !== -1;
                tableStructure[y][x].content =
                    `<div class="any-day-rule">
            <div class="${hasCycle ? 'cycle' : 'blue'}">&nbsp;</div>
            <div class="white">&nbsp;</div>
        </div>` + sanitized;
                tableStructure[y][x].classes.push(...bar.classes);
                tableStructure[y][x].dataAutomationRole = bar.dataAutomationRole;
                tableStructure[y][x].colspan = colspan;
            }
            gridStructure
                // sort by row number to make sure the row won't be rewritten when duplicated bar is added
                .sort((a, b) => getRowNumber(a) - getRowNumber(b))
                .forEach(cell => {
                var _a, _b, _c;
                const originalY = getRowNumber(cell);
                let y = originalY + additionalRows.filter(r => r < originalY).length;
                const x = getColNumber(cell);
                const colspan = getColSpan(cell);
                const cellValue = Utils.wrapElementIntoDiv(cell.value);
                const warning = cellValue.querySelector(warningSelector) !== null;
                if (warning) {
                    // Remove markup for warning icon as it creates a newline where the activity name goes
                    (_b = (_a = cellValue.querySelector(warningSelector)) === null || _a === void 0 ? void 0 : _a.parentElement) === null || _b === void 0 ? void 0 : _b.remove();
                }
                const sanitizedContent = sanitizeHtmlContent(cellValue.innerHTML);
                tableStructure[y][x - 1].warning = warning;
                if (!isAnyDay(cell.dataAutomationRole)) {
                    renderRegularCell(cell, sanitizedContent, y, x, colspan);
                    return;
                }
                const barId = cell.id;
                // make sure we display the bar only once
                if (placedBarIds.has(barId))
                    return;
                placedBarIds.add(barId);
                //make sure that the split bar will be displayed in the same row
                const sameBars = gridStructure.filter(c => c.id === barId);
                const hasIntersections = sameBars.some(c => this.doesBarIntersects(bars[originalY] || [], getColNumber(c), getColSpan(c)));
                // if the bar intersects with another one, we need to add an empty row
                // and display that bar on a new one
                if (hasIntersections) {
                    tableStructure.push(createEmptyRow());
                    tableStructure[y + ((_c = intersections[y]) !== null && _c !== void 0 ? _c : 0)][x].isParent = true;
                    intersections[y] = (intersections[y] || 0) + 1;
                    additionalRows.push(y);
                    y += intersections[y];
                    tableStructure[y][x].isDuplicated = true;
                    tableStructure[y][x].originalRow = originalY;
                }
                sameBars.forEach(bar => renderBar(bar, y));
            });
            let tableHtml = '';
            let colspanNum = 0;
            const mergeIntervals = (bars) => {
                // convert [start, end] format from input
                const intervals = bars.map(([start, end]) => [start, end]);
                // sort intervals by start
                intervals.sort((a, b) => a[0] - b[0]);
                const merged = [];
                for (const [start, end] of intervals) {
                    if (!merged.length || merged[merged.length - 1][1] < start - 1) {
                        // no overlap
                        merged.push([start, end]);
                    }
                    else {
                        // overlap: merge
                        merged[merged.length - 1][1] = Math.max(merged[merged.length - 1][1], end);
                    }
                }
                return merged;
            };
            const oneColumnRules = [constants.unscheduledVisitHeaderCell, constants.earlyTerminationHeaderCell];
            tableStructure.forEach((row, rowIndex) => {
                var _a;
                tableHtml += '<tr>';
                const isDuplicated = row.some(c => c.isDuplicated);
                const isParent = row.some(c => c.isParent);
                // for each overlapping bar we create a separate row to display it
                // for such rows find the merged cells and hide its borders, so it visually looks like one cell
                if (isDuplicated || isParent) {
                    const parentRowIndex = ((_a = row.find(c => c.originalRow)) === null || _a === void 0 ? void 0 : _a.originalRow) || rowIndex;
                    const mergedIntervals = mergeIntervals(bars[parentRowIndex] || []);
                    for (const [start, end] of mergedIntervals) {
                        const newEnd = start + end;
                        for (let i = start; i < newEnd; i++) {
                            if (i === start) {
                                tableStructure[rowIndex][i].classes.push('no-border-right');
                            }
                            else if (i === newEnd) {
                                tableStructure[rowIndex][i].classes.push('no-border-left');
                            }
                            else {
                                tableStructure[rowIndex][i].classes.push('no-border-left', 'no-border-right');
                            }
                        }
                    }
                }
                row.forEach((col, colIndex) => {
                    if (!colspanNum) {
                        if (oneColumnRules.includes(tableStructure[1][colIndex].dataAutomationRole)) {
                            col.classes.push('early-termination-header-cell');
                        }
                        if (colIndex !== 0 && rowIndex <= constants.headerRowsCountOfSOA) {
                            col.classes.push('font-size-10');
                        }
                        //differ between Group of activities vs Activities
                        if (rowIndex > constants.headerRowsCountOfSOA && colIndex === 1) {
                            if (!col.content.includes(constants.selectorSoaActivity)) {
                                col.classes.push('activity-group');
                            }
                        }
                        //hide the 1st row (zero point)
                        if (rowIndex === 0) {
                            col.content = '';
                        }
                        if (isDuplicated) {
                            col.classes.push('no-border-top');
                        }
                        if (isParent) {
                            col.classes.push('no-border-bottom');
                        }
                        const classes = col.classes.join(' ');
                        const colspan = col.colspan > 1 ? `colspan=${col.colspan}` : '';
                        const warningImage = col.warning ? warningIconImageHtml : '';
                        tableHtml += `<td ${colspan} class="${classes}">${warningImage}${col.content}</td>`;
                        colspanNum = col.colspan > 1 ? col.colspan : 0;
                    }
                    if (colspanNum > 0)
                        colspanNum--;
                });
                tableHtml += '</tr>';
            });
            const footnoteLinks = Array.from(document.querySelectorAll(`[data-document-parser-id="${constants.widgets.scheduleOfActivities.dataDocumentParserId}"] ${constants.selectorFootNote}`));
            for (let i = 0; i < footnoteLinks.length; i++) {
                const footnoteLink = footnoteLinks[i];
                const footnoteLinkText = footnoteLink.textContent;
                const parserFootnoteId = footnoteLink.getAttribute('data-document-parser-id');
                if (footnoteLinkText == null) {
                    continue;
                }
                const footnoteNumber = parseInt(footnoteLinkText);
                const footNoteSelector = `[data-document-parser-id="footNoteText-${parserFootnoteId}"]`;
                // Pre click workaround for second schedule first click not opening footnote for a second schedule.
                // the first link click wasn't programmatically bring up the footer popover, which causes a timeout.
                // Temp fix for this issues is to pre click the link twice to simulate an open and close of the footer popover,
                // allowing the actual selector to work in the loop fetching footnotes.
                if (i === 0) {
                    footnoteLink.click();
                    yield delay(50);
                    footnoteLink.click();
                    yield delay(50);
                }
                /* Make sure that the popup open from previous iteration is closed */
                (_l = document.querySelector('body')) === null || _l === void 0 ? void 0 : _l.click();
                yield delay(50);
                footnoteLink.click();
                let footnoteTextHolder;
                try {
                    footnoteTextHolder = yield waitForElementByInterval(footNoteSelector);
                }
                catch (_e) {
                    console.error('Footnote not found: ' + footNoteSelector);
                    footnoteLink.click();
                    try {
                        footnoteTextHolder = yield waitForElementByInterval(footNoteSelector);
                    }
                    catch (_e) {
                        console.error('Footnote not found: ' + footNoteSelector);
                        continue;
                    }
                }
                const footnoteText = footnoteTextHolder === null || footnoteTextHolder === void 0 ? void 0 : footnoteTextHolder.textContent.trim();
                footNotes[footnoteNumber] =
                    `<p><a name="footnote${stageName}${footnoteNumber}"></a> ${footnoteNumber}.&nbsp;${footnoteText}</p>`;
            }
            const footNotesValues = Object.values(footNotes);
            const html = `<table class="schedule-of-activities" style="border:1px solid #c4c8d3;">${tableHtml}</table>
                <br>
                ${hasWarning ? scheduleOfActivitiesWarningLegend : ''}
                ${footNotesValues.length
                ? `<div class="foot-notes"><h2>Footnotes</h2>${footNotesValues.join('')}</div><br>`
                : ''}`;
            (_m = document
                .querySelector(`[data-document-parser-block-editing="true"] button[data-document-parser-id="toggleEditButton"]`)) === null || _m === void 0 ? void 0 : _m.click();
            return TableWidgets.splitSOA(html, this.maxDocxColumnCount);
        });
    }
    /// Check if the new bar intersects with any existing bars
    doesBarIntersects(bars, newStart, newLength) {
        const newEnd = newStart + newLength - 1;
        return bars.some(([start, length]) => {
            const end = start + length - 1;
            return newStart <= end && start <= newEnd;
        });
    }
    static splitSOA(html, maxDocxColumnCount) {
        var _a, _b;
        const element = Utils.wrapElementIntoDiv(html);
        const columnCount = (_a = element.querySelectorAll('table tr:last-child td')) === null || _a === void 0 ? void 0 : _a.length;
        if (columnCount > maxDocxColumnCount) {
            const tables = [];
            const firstColumn = [];
            element.querySelectorAll('table tr').forEach((row, rowIndex) => {
                let colCount = 0, tableCount = 0;
                let tableRow = '';
                row.querySelectorAll('td').forEach((cell, cellIndex) => {
                    var _a, _b;
                    if (cellIndex === 0) {
                        firstColumn.push(cell.outerHTML);
                    }
                    if (cellIndex === 1 && firstColumn[rowIndex]) {
                        firstColumn[rowIndex] += cell.outerHTML;
                    }
                    let colspan = cell.colSpan;
                    let additionNumber = colspan ? colspan : 1;
                    if (colCount + additionNumber > maxDocxColumnCount ||
                        cellIndex === row.querySelectorAll('td').length - 1) {
                        cell.colSpan = colspan ? maxDocxColumnCount - colCount + 1 : 0;
                        tableRow += `${cell.outerHTML}`;
                        colspan -= cell.colSpan;
                        cell.colSpan = colspan;
                        if (tables[tableCount]) {
                            tables[tableCount] += `<tr>${tableRow}</tr>`;
                        }
                        else {
                            tables[tableCount] = `<tr>${tableRow}</tr>`;
                        }
                        tableRow = (_a = firstColumn[rowIndex]) !== null && _a !== void 0 ? _a : '';
                        colCount = 1;
                        tableCount++;
                        additionNumber = colspan ? colspan : 1;
                        if (colspan) {
                            if (cell.colSpan > maxDocxColumnCount) {
                                const numberOfRows = colspan / maxDocxColumnCount;
                                if (numberOfRows >= 1) {
                                    for (let i = 0; i < numberOfRows; i++) {
                                        if (additionNumber && colCount < maxDocxColumnCount) {
                                            if (colspan <= cell.colSpan && cell.colSpan >= maxDocxColumnCount) {
                                                cell.colSpan = colspan ? maxDocxColumnCount - colCount + 1 : 0;
                                                colspan -= cell.colSpan;
                                            }
                                            else {
                                                colspan *= -1;
                                            }
                                            tableRow += `${cell.outerHTML}`;
                                            cell.colSpan = colspan;
                                            additionNumber = colspan;
                                            if (colspan >= 0) {
                                                if (tables[tableCount]) {
                                                    tables[tableCount] += `<tr>${tableRow}</tr>`;
                                                }
                                                else {
                                                    tables[tableCount] = `<tr>${tableRow}</tr>`;
                                                }
                                                tableRow = (_b = firstColumn[rowIndex]) !== null && _b !== void 0 ? _b : '';
                                                colCount = 1;
                                                tableCount++;
                                            }
                                            else {
                                                colCount = colspan * -1 + 1;
                                            }
                                        }
                                    }
                                }
                            }
                            else {
                                tableRow += `${cell.outerHTML}`;
                                colCount += additionNumber;
                            }
                        }
                    }
                    else {
                        tableRow += `${cell.outerHTML}`;
                        colCount += additionNumber;
                    }
                });
            });
            const footNotes = (_b = element.querySelector('.foot-notes')) === null || _b === void 0 ? void 0 : _b.outerHTML;
            html = '';
            tables.forEach(t => {
                html += dompurify.sanitize(`<table class="schedule-of-activities">${t}</table><br>`);
            });
            html += dompurify.sanitize(footNotes !== null && footNotes !== void 0 ? footNotes : '');
        }
        return TableWidgets.customizeSOAStyles(html);
    }
    /**
     * Since both docx and Google Docs don't support complicated CSS rules -
     * need to add specific classes to the elements we need to customize
     * @param {string} html
     * @returns {string}
     * @private
     */
    static customizeSOAStyles(html) {
        const element = Utils.wrapElementIntoDiv(html);
        element.querySelectorAll('table').forEach(t => {
            constants.SOAClasses.forEach(c => {
                t.querySelectorAll(c.selector).forEach(e => {
                    e.classList.add(...c.class);
                });
            });
        });
        return element.innerHTML;
    }
    /**
     * Scrapes Table Widget without any additional controls inside
     * @param {string} widgetName - name of the scraped widget, {@link widgets} definition
     * @return {string} - valid HTML table
     */
    getTableWidget(widgetName) {
        var _a, _b;
        if (widgetName in constants.widgets) {
            const html = Utils.cloneNode(constants.widgets[widgetName].dataDocumentParserId);
            if (html) {
                return `${(_b = (_a = this.formatTable(html)) === null || _a === void 0 ? void 0 : _a.outerHTML) !== null && _b !== void 0 ? _b : ''} <br>`;
            }
        }
        return '';
    }
    /**
     * For parsing Dosing and Intervention Groups. We need this function because of 1st column with colors
     * @returns {string}
     */
    getStudyInterventionGroups() {
        var _a, _b;
        const html = Utils.cloneNode(constants.widgets.interventionGroups.dataDocumentParserId);
        if (html) {
            html.querySelectorAll(constants.colorSwatch).forEach(e => {
                var _a;
                (_a = e.closest('td')) === null || _a === void 0 ? void 0 : _a.classList.add('intervention-group-color');
                e.outerHTML = `<div style="color:${e.style.backgroundColor}">•</div>`;
                e.style.backgroundColor = '';
            });
            return `${(_b = (_a = this.formatTable(html)) === null || _a === void 0 ? void 0 : _a.querySelector('table')) === null || _b === void 0 ? void 0 : _b.outerHTML}<br>`;
        }
        return '';
    }
    /**
     * Apply same style rules for all table widgets in the Study
     * @param {Element | null} table
     * @returns {Element | null}
     */
    formatTable(table) {
        var _a;
        if (table) {
            table.querySelectorAll(constants.tableHiddenCell).forEach(c => c.remove());
            Utils.clearTableFromInputs(table);
            table.querySelectorAll('th').forEach(t => {
                t.textContent = toUpper(t.textContent);
            });
            (_a = (table.tagName === 'TABLE' ? table : table.querySelector('table'))) === null || _a === void 0 ? void 0 : _a.classList.add(constants.classTableWidget);
            //adding a space before the table
            //margin style might not work if table is wrapped with set of div elements
            const wrapper = document.createElement('div');
            wrapper.innerHTML = `<br/>${table.outerHTML}<br/>`;
            return wrapper;
        }
        return table;
    }
}
//# sourceMappingURL=table-widgets.js.map